import React from 'react';
import './input-checkbox.sass';

export const CheckboxStyle = {
    PRIMARY: 'primary',
    UNIQUE_LANDING_PAGE: 'unique-landing-page',
    SECONDARY: 'secondary',
};

export const CheckboxAlign = {
    TOP: 'top',
    CENTER: 'center'
};

export const InputCheckbox = ({name, value, id, label, link, defaultChecked, onChange, textError, style = CheckboxStyle.PRIMARY, labelComponent, align = CheckboxAlign.CENTER }) => {

  return (
    <div className='vv-input-checkbox-container'>
      <label className={`vv-checkbox vv-checkbox--align-${align} vv-checkbox-before vv-checkbox-before--${style}`}>
        <span className='vv-checkbox__input'>
          <input type='checkbox' id={id} name={name} value={value} onChange={onChange} defaultChecked={defaultChecked}/>
          <span className={`vv-checkbox__control vv-checkbox__control--${style} ${textError ? 'vv-checkbox__error' : ''}`}/>
        </span>
          {
              labelComponent ? labelComponent :
                  <a href={link} target='_blank' rel='noopener noreferrer' className={`vv-checkbox__label vv-checkbox__label--${style}`}>{label}</a>
          }
      </label>
    </div>
  );
};